export default function PaiementsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('paiements');
}

PaiementsConfiguration.$inject = ['$translatePartialLoaderProvider'];
